import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Star } from "lucide-react";
import { TESTIMONIALS } from "../lib/funnelData";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];

  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="max-w-2xl mx-auto" data-testid="testimonials">
      <div className="flex justify-center gap-1" data-testid="testimonial-stars">
        {Array.from({ length: 5 }).map((_, s) => (
          <Star key={s} size={14} className="fill-oak text-oak" />
        ))}
      </div>
      <div className="mt-4 min-h-[120px] sm:min-h-[92px]">
        <AnimatePresence mode="wait" initial={false}>
          <motion.figure key={i} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.3 }} data-testid="testimonial-card">
            <blockquote className="text-sm sm:text-base font-serif text-white/90 leading-relaxed [text-wrap:pretty]">“{t.quote}”</blockquote>
            <figcaption className="mt-3">
              <span className="text-xs font-bold text-white">{t.name}</span>
              <span className="ml-2 text-[10px] font-mono uppercase tracking-[0.2em] text-white/50">{t.tag}</span>
            </figcaption>
          </motion.figure>
        </AnimatePresence>
      </div>
      <div className="mt-4 flex items-center justify-center gap-3">
        <button
          data-testid="testimonial-prev-btn"
          onClick={() => setI((i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
          className="w-8 h-8 rounded-full border border-white/25 flex items-center justify-center text-white/80 hover:bg-white/10 transition-colors duration-150 active:scale-[0.96]"
          aria-label="Previous testimonial"
        >
          <ArrowLeft size={14} />
        </button>
        <span className="text-[10px] font-mono text-white/50 tabular-nums">{i + 1} / {TESTIMONIALS.length}</span>
        <button
          data-testid="testimonial-next-btn"
          onClick={() => setI((i + 1) % TESTIMONIALS.length)}
          className="w-8 h-8 rounded-full border border-white/25 flex items-center justify-center text-white/80 hover:bg-white/10 transition-colors duration-150 active:scale-[0.96]"
          aria-label="Next testimonial"
        >
          <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
};
